<template>
  <div>
    <screen
      v-show="show"
      class="fixed top-0 left-0 justify-start"
      :can-skip="false"
      :can-leave="false"
      @leave="$emit('cancel')"
    >
      <!-- Prompt -->
      <RoundedCard
        :height="`70%`"
        :show-right-btn="!isError"
        class="p-3"
        @set-close-status="checkScanRecords"
      >
        <IncompleteAlert v-if="isError" @confirm="checkScanRecords" @cancel="abort" />
        <MyQrCode v-else />
        <transition v-if="isFetching" name="fade">
          <LoadingSpinner class="loading-spinner" />
        </transition>
      </RoundedCard>
    </screen>
  </div>
</template>
<script>
import $api from '@/modules/request';
import Screen from '@/components/common/Screen.vue';
import RoundedCard from '@/components/common/RoundedCard.vue';
import MyQrCode from './MyQrCode.vue';
import IncompleteAlert from './IncompleteAlert.vue';
import LoadingSpinner from './LoadingSpinner.vue';

export default {
  components: {
    Screen,
    RoundedCard,
    MyQrCode,
    IncompleteAlert,
    LoadingSpinner,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isError: false,
      isFetching: false,
    };
  },
  methods: {
    async checkScanRecords() {
      if (this.isFetching) return;

      try {
        this.isFetching = true;
        const { data } = await $api.user.get('/api/v1/scan_records');
        if (data.records.length) {
          this.$emit('done');
        } else {
          this.isError = true;
        }
      } catch (err) {
        console.log('error', err);
      } finally {
        this.isFetching = false;
      }
    },
    abort() {
      this.$emit('cancel');
      this.isError = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.loading-spinner {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave {
  opacity: 1;
}
</style>
